import { render, staticRenderFns } from "./basic-setting.vue?vue&type=template&id=847ae7ec&"
import script from "./basic-setting.vue?vue&type=script&lang=js&"
export * from "./basic-setting.vue?vue&type=script&lang=js&"
import style0 from "./basic-setting.vue?vue&type=style&index=0&id=847ae7ec&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports